import { defaultTo } from 'lodash';

export interface IModel {
  rowVersion: string;
}

export type ModelRecord<T> = Record<keyof T, any> & IModel;

export class Model implements IModel {
  rowVersion: string;

  constructor(params?: Partial<IModel>) {
    this.rowVersion = defaultTo(params?.rowVersion, '');
  }
}
